import tw, { styled } from "twin.macro";

export const HomeContainer = styled.div`
  ${tw`
  
`}
`;

export const HomeRow = styled.div`
  ${tw`
  flex
  z-10
`}

  margin-left: 5px;
  margin-right: 5px;
`;
